import { render } from "./Msc.vue?vue&type=template&id=5fad52a4"
import script from "./Msc.vue?vue&type=script&lang=js"
export * from "./Msc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__